import { Dispatch, FC, SetStateAction } from "react";
import Department from "../../types/Department";
import DepartmentGroup from "../../types/DepartmentGroup";
import { Autocomplete, TextField } from "@mui/material";
import { deepPurple } from "@mui/material/colors";

const sxStyles = {
  deptSelector: {
    width: "13.75rem",
    background: "white",
  },
  input: {
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: deepPurple[800] + " !important",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: deepPurple[800],
    },
  },
};

interface DepartmentSelectorProps {
  departments: Department[];
  departmentGroups: DepartmentGroup[];
  defaultDepartment: string;
  setSelectedDept: Dispatch<SetStateAction<Record<string, any>>>;
  handleUpdateDefaultDepartment: (string) => void;
}

const DepartmentSelector: FC<DepartmentSelectorProps> = ({
  departments,
  departmentGroups,
  defaultDepartment,
  setSelectedDept,
  handleUpdateDefaultDepartment,
}) => {
  const deptNames = departments.map((d) => {
    return {
      id: d.department_name,
      label: d.department_display_name
        ? d.department_display_name
        : d.department_name,
      hospitalID: d.qv_hospital_id,
      isHospitalWide: d.is_hospital_wide,
      eddWindow: d.edd_window,
    };
  });

  const deptGroupNames = departmentGroups.map((dg) => {
    return {
      id: String(dg.id),
      label: dg.group_name,
      hospitalID: null,
      isHospitalWide: null,
      eddWindow: null,
    };
  });

  const deptOptions = deptNames
    .concat(deptGroupNames)
    .sort((a, b) => a.label.localeCompare(b.label));

  const defaultValue = deptOptions.find(
    (d) => d.id === defaultDepartment || d.label === defaultDepartment
  )?.label;

  const compareOptions = (option, value) => {
    return option.id === value.id;
  };

  const handleSelectDept = (event, value) => {
    if (value) {
      setSelectedDept(value);
      handleUpdateDefaultDepartment(value);
    }
  };

  return (
    <Autocomplete
      disablePortal
      options={deptOptions}
      value={defaultValue}
      isOptionEqualToValue={compareOptions}
      sx={sxStyles.deptSelector}
      renderInput={(params) => (
        <TextField
          {...params}
          label="View"
          size="small"
          placeholder="Search by keyword"
          sx={sxStyles.input}
        />
      )}
      onChange={handleSelectDept}
    />
  );
};

export default DepartmentSelector;
